import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BulkDocAddPayload } from '@models/review/bulk-doc-add-payload.model';
import { SelectionService } from '@models/review/selection-service';
import { SearchParameter } from '@models/review/search-parameter.model';
import { ProductionJobDialogComponent } from '@dialogs/production-job-dialog/production-job-dialog.component';
import { EmailFamilyCountManager } from '@managers/email-family-count.manager';
import { ProductionJobSdk } from 'src/app/sdks/production-job.sdk';
import { ProductionJobView } from '@models/ui/production-job-view.model';
import { NotificationManager } from '@managers/notification.manager';
import { UserConfigs } from '@models/user-configs.model';
import { UserResource } from '@models/resource/user.resource';
import { CreateProductionJobDialogComponent } from '../../discovery/dialogs/create-production-job-dialog/create-production-job-dialog.component';
import { ProductionJobsStore } from '@store/legacy/production-jobs.store';


@Component({
    selector: 'lex-production-job-select',
    templateUrl: './production-job-select.component.html',
    styleUrls: ['./production-job-select.component.scss'],
    standalone: false
})
export class ProductionJobSelectComponent implements OnInit {
	@Input() searchParameter: SearchParameter;
	@Input() isProcessingOrIndexing: boolean;
	@Input() expandEmailFamilySelected: boolean;
	public productionJobs: ProductionJobView[] = new Array<ProductionJobView>();

	@ViewChild('productionJobSelect') selectProductionJob: MatSelect;

	public userConfig: UserConfigs;
	public users: UserResource[] = [];
	public createdJob: ProductionJobView = null;
	public canceled: boolean = null;

	constructor(
		private emailFamilyCountManager: EmailFamilyCountManager,
		public selectionService: SelectionService,
		private dialog: MatDialog,
		private productionJobSdk: ProductionJobSdk,
		private notificationManager: NotificationManager,
		private productionJobsStore: ProductionJobsStore
	) {
	}

	public handleDocsAdded(success: boolean) {
		let feedback = '';
		if (success === true)
			feedback = 'Documents added';
		else if (success === false)
			feedback = 'Documents have already been added';
		else
			feedback = 'There was an error';

		this.selectionService.operationAlert = feedback;
	}

	public ngOnInit() {
		this.productionJobsStore.loadAllJobs();
		this.productionJobsStore.productionJobs$.subscribe(data => this.productionJobs = data);
		this.productionJobsStore.createdJob$.subscribe(data => this.createdJob = data);
		this.productionJobsStore.canceled$.subscribe(data => this.canceled = data);
	}

	public addDocs(change: MatSelectChange): void {
		if (this.isProcessingOrIndexing) {
			this.selectionService.operationAlert = 'Documents cannot be added to a Production Job while processing and/or indexing is in progress.';
			return;
		}
		const payload: BulkDocAddPayload = this.createBulkPayload();
		this.emailFamilyCountManager.GetExpandedEmailFamilyDocCount(payload).subscribe(data => this.openDialog(change, data));
	}

	public addProdJob(): void {
		this.showCreateProductionJobDialog();
		this.selectProductionJob.value = null;
	}

	private showCreateProductionJobDialog(): void {
		this.selectionService.operationAlert = null;
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.width = '1050px';
		dialogConfig.maxWidth = '1050px';

		this.dialog.open(CreateProductionJobDialogComponent, dialogConfig).afterClosed()
			.subscribe({
				next: (result) => {

					if (!result?.productionCreated) return;

					if (this.selectionService.SelectedCount > 0) {
						this.selectProductionJob.value = this.createdJob;
						this.addDocs({source: this.selectProductionJob, value: this.selectProductionJob.value});
					}

					this.notificationManager.displaySnackBarMessage({
						message: `Production Job successfully created!`,
						type: 'info'
					});

					this.productionJobsStore.loadAllJobs();
				},
				error: (err) => {
					this.notificationManager.displaySnackBarMessage({
						message: `An error occurred while creating your Production Job. Please confirm your records and try again.`,
						type: 'warn'
					});
					throw new Error(err.message);
				}
			});
	}

	private openDialog(change: MatSelectChange, emailFamilyCount: number) {
		this.selectionService.operationAlert = null;
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.data = {
			productionJob: change.value,
			selectedCount: this.selectionService.SelectedCount,
			emailFamilyCount: emailFamilyCount
		};
		dialogConfig.panelClass = 'add-docs-to-job-panel';

		this.dialog.open(ProductionJobDialogComponent, dialogConfig).afterClosed().subscribe((addDocRequest: BulkDocAddPayload) => {
			if (addDocRequest) {
				addDocRequest.docIds = this.selectionService.selection.selected.map(s => s.docId);
				addDocRequest.selectAll = this.selectionService.selectAllFlag;
				addDocRequest.filterId = this.selectionService.getSavedFilterId();
				addDocRequest.searchParameter = this.searchParameter;
				this.productionJobSdk.addDocsToProductionJob(change.value.productionJobId, addDocRequest)
					.subscribe(data => this.handleDocsAdded(data));
			}
			const matSelect: MatSelect = change.source;
			matSelect.writeValue(null);


		});

		const matSelect: MatSelect = change.source;
		matSelect.writeValue(null);
	}

	private createBulkPayload(): BulkDocAddPayload {
		const payload: BulkDocAddPayload = new BulkDocAddPayload();

		payload.docIds = this.selectionService.selection.selected.map(s => s.docId);
		payload.selectAll = this.selectionService.selectAllFlag;
		payload.filterId = this.selectionService.getSavedFilterId();
		payload.searchParameter = this.searchParameter;

		return payload;
	}


}
